<template>
    <v-container class="azul--text">
        <!--Carrito-->
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="azul--text">
                        Mi Carrito
                        <v-spacer />
                        <!--<v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                        />-->
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="cart"
                        hide-default-footer
                    >
                        <template #item.delete="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="REMOVEFROMCART(item.product)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <template #item.nombre="{item}">
                            {{ getDesc(item.product) }}
                        </template>
                        <template #item.laboratorio="{item}">
                            {{ item.product.grupo1 }}
                        </template>
                        <template #item.publico="{item}">
                            {{ item.product.precio1 }}
                        </template>
                        <template #item.cantidad="{item}">
                            <v-flex md4>
                                <v-text-field
                                    :value="item.cantidad"
                                    @input.native="changeCantidad($event, item)"
                                    type="number"
                                />
                            </v-flex>
                        </template>
                        <!-- Aca hay q hacer una funcion
                        Tiene que ver que descuento le da dependiendo de la cantidad de
                        unidades y si tiene descuento x cantidad
                        -->
                        <template #item.descuento="{item}">
                            <div v-if="validateCartDiscount2(item)">
                                <!-- Tacho 2 ofertas superadas-->
                                <span
                                    style="
                                        text-decoration: line-through;
                                        text-decoration-style: solid;
                                    "
                                >
                                    % {{ getMayorDiscount(item.product) }}
                                </span>
                                <span
                                    class="red--text"
                                    style="
                                        text-decoration: line-through;
                                        text-decoration-style: solid;
                                    "
                                >
                                    % {{ getQuantityDiscount(item.product) }}
                                </span>
                                <span class="red--text">
                                    % {{ getQuantityDiscount2(item.product) }}
                                </span>
                            </div>
                            <div v-else-if="validateCartDiscount(item)">
                                <!-- Tacho 1 oferta superada-->
                                <span
                                    style="
                                        text-decoration: line-through;
                                        text-decoration-style: solid;
                                    "
                                >
                                    % {{ getMayorDiscount(item.product) }}
                                </span>
                                <span class="red--text">
                                    % {{ getQuantityDiscount(item.product) }}
                                </span>
                            </div>

                            <div v-else>
                                % {{ getMayorDiscount(item.product) }}
                            </div>
                        </template>
                        <template #item.precio="{item}">
                            {{ getPrecio(item) }}
                        </template>
                        <template #item.total="{item}">
                            {{ getPrecioTotal(item) }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <!--Resumen de pedido-->
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="azul--text">
                        Resumen del pedido
                    </v-card-title>
                    <v-container class="azul--text lighten-2">
                        <v-row>
                            <v-col cols="4"></v-col>
                            <v-col align="center" cols="3">
                                Total Gravado:
                            </v-col>
                            <v-col align="end" cols="2">
                                $
                            </v-col>
                            <v-col align="end" cols="2">
                                {{ totalConIva }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4"></v-col>
                            <v-col align="center" cols="3">
                                Iva:
                            </v-col>
                            <v-col align="end" cols="2">
                                $
                            </v-col>
                            <v-col align="end" cols="2">
                                {{ totalIva }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4"></v-col>
                            <v-col align="center" cols="3">
                                Total Exento:
                            </v-col>
                            <v-col align="end" cols="2">
                                $
                            </v-col>
                            <v-col align="end" cols="2">
                                {{ totalSinIva }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="7"></v-col>
                            <v-col cols="5">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4"></v-col>
                            <v-col align="center" cols="3">
                                <strong>Total:</strong>
                            </v-col>
                            <v-col align="end" cols="2">
                                $
                            </v-col>
                            <v-col align="end" cols="2">
                                <strong>
                                    {{ totalTotal }}
                                </strong>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <!--Texto Valor minimo de compra-->
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        <span class="azul--text">
                            El valor mínimo de compra es de
                            <b>{{ minimoCompra }}</b>
                        </span>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <!--Boton confirmar pedido-->
        <v-row>
            <v-col cols="12" align="end">
                <v-btn dark color="azul" @click="enviarConfirmacion">
                    Confirmar Pedido
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import gd from '../utils/getDesc';
import gmd from '../utils/Discounts/getMayorDiscount';
import gqd from '../utils/Discounts/getQuantityDiscount';
import gqd2 from '../utils/Discounts/getQuantityDiscount2';

export default {
    data: () => ({
        minimoCompra: 2000,
        search: '',
        headers: [
            {
                text: '',
                value: 'delete',
                sortable: false,
                align: 'center'
            },
            { text: 'Laboratorio', value: 'laboratorio', sortable: false },
            { text: 'Producto', value: 'nombre', sortable: false },
            { text: 'Cantidad', value: 'cantidad', sortable: false },
            { text: 'Publico', value: 'publico', sortable: false },
            { text: 'Descuento', value: 'descuento', sortable: false },
            { text: 'Precio', value: 'precio', sortable: false },
            { text: 'Total', value: 'total', sortable: false }
        ]
    }),
    computed: {
        ...mapState('products', ['cart']),
        //Excento
        totalSinIva() {
            let t = 0;
            this.cart.forEach(e => {
                if (e.product.iva == 0) t += this.getPrecioTotal(e);
            });
            return parseInt(t.toFixed(2));
        },
        //Iva
        totalIva() {
            let t = 0;
            this.cart.forEach(e => {
                if (e.product.iva != 0) t += this.getPrecioTotal(e);
            });
            return parseInt((t - this.totalConIva).toFixed(2));
        },
        //Gravado
        totalConIva() {
            let t = 0;
            this.cart.forEach(e => {
                if (e.product.iva != 0)
                    t += this.getPrecioTotal(e) / (1 + e.product.iva / 100);
            });
            return parseInt(t.toFixed(2));
        },
        totalTotal() {
            return this.totalSinIva + this.totalConIva + this.totalIva;
        }
    },

    methods: {
        ...mapMutations('products', [
            'REMOVEFROMCART',
            'DISMINUIR_CANTIDAD',
            'AUMENTAR_CANTIDAD',
            'SET_CART',
            'SET_CANTIDAD'
        ]),
        getDesc: gd,
        getMayorDiscount: gmd,
        getQuantityDiscount: gqd,
        getQuantityDiscount2: gqd2,
        enviarConfirmacion() {
            if (this.totalTotal >= this.minimoCompra) {
                this.$router.push({ name: 'Confirmation' });
            }
        },
        /*incrementCantidad(event, item) {
            this.AUMENTAR_CANTIDAD(item);
            console.log(event);
        },
        decrementCantidad(event, item) {
            this.DISMINUIR_CANTIDAD(item);
            console.log(event);
        },*/
        changeCantidad(event, item) {
            if (event.target.value < 1) {
                event.target.value = item.cantidad;
                return;
            }
            this.SET_CANTIDAD({ item, cant: event.target.value });
        },
        getPrecioTotal(item) {
            return parseInt((this.getPrecio(item) * item.cantidad).toFixed(2));
        },
        getPrecio(item) {
            return (
                item.product.precio1 -
                (item.product.precio1 * this.getDiscount(item)) / 100
            ).toFixed(2);
        },
        //Rearmar con nuevos descuentos
        getDiscount(item) {
            if (this.validateCartDiscount2(item)) {
                return this.getQuantityDiscount2(item.product);
            } else if (this.validateCartDiscount(item)) {
                return this.getQuantityDiscount(item.product);
            }
            return this.getMayorDiscount(item.product);
        },
        //Validate discounts in cart
        validateCartDiscount(item) {
            if (
                item.cantidad >= item.product.ca1 &&
                item.product.ca1 > 1 &&
                item.product.po1 > item.product.bonif1
            ) {
                return true;
            }
            return false;
        },
        validateCartDiscount2(item) {
            if (
                this.validateCartDiscount(item) &&
                item.cantidad >= item.product.ca2 &&
                item.product.po2 > item.product.po1
            ) {
                return true;
            }
            return false;
        }
    }
};
</script>
<style scoped>
div span {
    padding-right: 7px;
}
.v-input input,
.v-text-field {
    max-width: 30px;
}
</style>
